import { CustomisableCategoryType } from './customisable-category-type';
import { TranslatedText } from './translated-text';

export class CustomisableCategory {
  id: string;
  name: string | TranslatedText;
  max: number;
  min: number;
  type: CustomisableCategoryType;
  autoBalance: boolean;
  products: any[];

  constructor(
    id: string,
    name: string | TranslatedText,
    max: number,
    min: number,
    type: CustomisableCategoryType,
    products: any[],
    autoBalance = false,
  ) {
    this.id = id;
    this.name = typeof name === "string" ? new TranslatedText(name) : name;
    this.max = max;
    this.min = min;
    this.type = type;
    this.autoBalance = autoBalance;
    this.products = products;
  }

  toGenericObject() {
    return JSON.parse(JSON.stringify(this));
  }
}
